import { useState } from 'react';

import { Extensions } from 'components/app/_mediator/app-data.slice';
import { Button } from 'components/UI/button/button';
import styles from './_picker.module.scss';

type Props = {
  rejected: File[];
  extensions: Extensions;
};

export const ToastRejectedFiles = ({ rejected, extensions }: Props) => {
  const [showExt, setShowExt] = useState(false);
  return (
    <div className={styles.RejectedFilesToast}>
      <p>Rejected files due to unsupported file types:</p>
      <ul className={styles.RejectedFilesToast__rejected}>
        {rejected.map((f) => (
          <li key={f.name}>{f.name}</li>
        ))}
      </ul>
      {!showExt ? (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            setShowExt(!showExt);
          }}
        >
          Show allowed extensions
        </Button>
      ) : (
        <div className={styles.RejectedFilesToast__extensions}>
          {Object.keys(extensions).map((ext) => (
            <div key={ext}>
              <strong>{ext}</strong>
              <ul>
                {extensions[ext as keyof Extensions].map((ext) => (
                  <li key={ext}>{ext}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
